import { useTranslation } from 'react-i18next'
import { Typography } from 'antd'
import { Page } from '../structure'
import i18n from '../i18n'
import { useCustomisation } from '../hooks/useCustomisation'
import { LoginRegisterForms } from '../components/LoginRegisterForms'
import { useSearch } from '@tanstack/react-router'

const Login = () => {
  const { t } = useTranslation()
  const { theme } = useCustomisation()
  const layout = theme.loginBGImage ? 'page-bg-image' : ''
  const search = useSearch({ from: '/' })
  const from = search.from || '/'

  return (
    <Page className="login" layout={layout} title={t('Login.Title')}>
      {i18n.exists('Login.Headline') && (
        <Typography.Title className="headline" level={2}>
          <center>{t('Login.Headline')}</center>
        </Typography.Title>
      )}
      <LoginRegisterForms
        showRegisterForm={theme.showRegisterForm}
        redirectPath={from}
      />
    </Page>
  )
}

export default Login
